import dynamic from "next/dynamic";

export const AwardsCarousel = dynamic(() => import("./component"));
